export const RESULT_HEADER_GRADIENTS = [
	'linear-gradient(180deg, #FCE007 0%, #F99D20 100%)',
	'linear-gradient(180deg, #1952D8 0%, #3D1AE8 100%)',
	'linear-gradient(180deg, #D81985 0%, #E81A1E 100%)',
];

export const RESULT_HEADER_TEXT_COLORS = ['#520612', 'white', 'white'];

export const RESULT_BALLS = {
	2: ['purple', 'blue'],
	default: ['purple', 'red', 'blue'],
};
